import { createBrowserRouter } from 'react-router';

import { AssetDetail } from '@/components/assets/asset-details/asset-detail';
import { AssetDetailOutlet } from '@/components/assets/asset-details/outlet';
import AssetsPageV1 from '@/components/assets/asset-list/pageV1';
import { DamageDetail } from '@/components/damage/damage-detail';
import { FinanceList } from '@/components/finance/FinanceList';
import { WorkPackageDetail } from '@/components/finance/work-packages/WorkPackageDetail';
import { HealthMonitoringLayout } from '@/components/health-monitoring/HealthMonitoringLayout';
import { InspectionDetail } from '@/components/inspection/inspection-details/inspection-detail';
import { Login } from '@/containers/login';
import { MainLayout } from '@/MainLayout';
import { AssetMainOutlet } from '../components/assets/AssetMainOutlet';
import { AssetsPageV2 } from '../components/assets/asset-list/pageV2';
import { AssetsPageV3 } from '../components/assets/asset-list/pageV3';
import { LifespanPage } from '../components/LifespanPage';
import { PageLoader } from '../components/PageLoader';
import { TimePlanningPage } from '../components/TimePlanningPage';
import { Administration } from '../containers/Administration';
import { SentryDebug } from '../containers/SentryDebug';
import { SSOCallback } from '../containers/SSOCallback';
import { authMiddleware } from './auth/middleware';
import { profileLoader } from './loader/profile';

export const router = createBrowserRouter([
	{
		path: '/',
		Component: MainLayout,
		middleware: [authMiddleware],
		HydrateFallback: PageLoader,
		children: [
			{ index: true, loader: profileLoader, Component: AssetsPageV1 },
			{
				path: 'assets/:assetId',
				Component: AssetMainOutlet,
				children: [
					{
						path: '',
						loader: profileLoader,
						Component: AssetDetailOutlet,
						children: [
							{
								index: true,
								Component: AssetDetail,
							},
							{
								path: 'inspections/:inspectionId',
								Component: InspectionDetail,
							},
							{
								path: 'inspections/:inspectionId/damages/:damageId',
								Component: DamageDetail,
							},
						],
					},
					{
						path: 'finance',
						loader: profileLoader,
						children: [
							{
								index: true,
								Component: FinanceList,
							},
							{
								path: 'work-packages/:workPackageId',
								Component: WorkPackageDetail,
							},
						],
					},
					{
						path: 'time-planning',
						Component: TimePlanningPage,
					},
					{
						path: 'health',
						Component: HealthMonitoringLayout,
					},
					{
						path: 'lifespan',
						Component: LifespanPage,
					},
				],
			},
			{
				path: 'administration',
				Component: Administration,
			},
		],
	},
	{
		path: '/v1',
		Component: MainLayout,
		middleware: [authMiddleware],
		HydrateFallback: PageLoader,
		children: [{ index: true, loader: profileLoader, Component: AssetsPageV1 }],
	},
	{
		path: '/v2',
		Component: MainLayout,
		middleware: [authMiddleware],
		HydrateFallback: PageLoader,
		children: [{ index: true, loader: profileLoader, Component: AssetsPageV2 }],
	},
	{
		path: '/v3',
		Component: MainLayout,
		middleware: [authMiddleware],
		HydrateFallback: PageLoader,
		children: [{ index: true, loader: profileLoader, Component: AssetsPageV3 }],
	},
	{
		path: '/login',
		Component: Login,
	},
	{
		path: 'sso-callback',
		Component: SSOCallback,
	},
	// Intentionally outside authMiddleware: when a deployment isn't reporting errors,
	// logging in is often the thing you can't do. Never registered in production:
	// it is unauthenticated and only exists to verify a deployment's Sentry wiring.
	...(import.meta.env.VITE_SENTRY_ENVIRONMENT === 'production'
		? []
		: [
				{
					path: '/debug/sentry',
					Component: SentryDebug,
				},
			]),
]);
